import React, { useState, Fragment, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import API from '../../services/API';

const OfficerPage = () => {
  const [students, setStudents] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [twinSearch, setTwinSearch] = useState({});
  const [twinResults, setTwinResults] = useState({});
  const [expandedRows, setExpandedRows] = useState({});

  const searchTwinCandidates = async (student_uuid, q) => {
    try {
      const res = await API.get(
        `/portal/getStudents?page=1&limit=10&search=${encodeURIComponent(q)}`,
        {
          headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('token'),
          },
        }
      );

      if (res.data.response_code === 1000) {
        const results = res.data.data.students.filter(
          (s) => s.student_uuid !== student_uuid
        );
        setTwinResults((prev) => ({ ...prev, [student_uuid]: results }));
      }
    } catch {
      toast.error('Carian pegawai berkaitan gagal');
    }
  };

  const pairTwin = async (student_uuid, twin_student_id) => {
    try {
      const res = await API.post(
        '/student/updateTwinStatus',
        { student_uuid, is_twin: 1, twin_student_id },
        {
          headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('token'),
          },
        }
      );

      if (res.data.response_code === 1000) {
        toast.success('Pegawai berjaya dipadankan');

        setStudents((prev) => {
          const twin = prev.find((s) => s.student_uuid === twin_student_id);
          const current = prev.find((x) => x.student_uuid === student_uuid);

          return prev.map((s) =>
            s.student_uuid === student_uuid
              ? {
                  ...s,
                  is_twin: 1,
                  twin_student_id,
                  twin_name: twin?.first_name,
                  twin_profile_pic: twin?.profile_pic,
                  twin_class_name: twin?.class_name,
                }
              : s.student_uuid === twin_student_id
              ? {
                  ...s,
                  is_twin: 1,
                  twin_student_id: student_uuid,
                  twin_name: current?.first_name,
                  twin_profile_pic: current?.profile_pic,
                  twin_class_name: current?.class_name,
                }
              : s
          );
        });

        setTwinResults((prev) => ({ ...prev, [student_uuid]: [] }));
        setTwinSearch((prev) => ({ ...prev, [student_uuid]: '' }));
      } else {
        toast.error(res.data.message || 'Gagal memadankan pegawai');
      }
    } catch {
      toast.error('Ralat semasa memadankan pegawai');
    }
  };

  const fetchStudents = (page = 1, limit = 10, searchTerm = '') => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

    let url = `/portal/getStudents?page=${page}&limit=${limit}`;

    if (searchTerm) {
      url += `&search=${encodeURIComponent(searchTerm)}`;
    }

    API.get(url, { headers })
      .then((response) => {
        if (response.data.response_code === 1000) {
          setStudents(response.data.data.students || []);
          setTotalRows(response.data.data.total || 0);
        } else {
          toast.error(response.data.message || 'Gagal mendapatkan senarai pegawai', {
            autoClose: 5000,
          });
        }
      })
      .catch(() =>
        toast.error('Ralat semasa mendapatkan senarai pegawai', {
          autoClose: 5000,
        })
      );
  };

  const fetchStudentSummary = (studentId) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

    API.get(`/analytics/attendance/studentSummary?student_id=${studentId}`, {
      headers,
    })
      .then((response) => {
        if (response.data.response_code === 1000) {
          setExpandedRows((prev) => ({
            ...prev,
            [studentId]: response.data.data,
          }));
        } else {
          toast.error(response.data.message || 'Gagal mendapatkan ringkasan kehadiran', {
            autoClose: 5000,
          });
        }
      })
      .catch(() =>
        toast.error('Ralat semasa mendapatkan ringkasan kehadiran', {
          autoClose: 5000,
        })
      );
  };

  const updateTwinStatus = async (student_uuid, is_twin) => {
    try {
      const res = await API.post(
        '/student/updateTwinStatus',
        { student_uuid, is_twin },
        {
          headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('token'),
          },
        }
      );

      if (res.data.response_code === 1000) {
        toast.success('Status padanan berjaya dikemaskini');
      } else {
        toast.error(res.data.message || 'Gagal mengemaskini status padanan');
      }
    } catch {
      toast.error('Ralat semasa mengemaskini status padanan');
    }
  };

  const handleTwinToggle = async (student_uuid, checked) => {
    if (!checked) {
      confirmUnpair(async () => {
        await updateTwinStatus(student_uuid, 0);

        setStudents((prev) =>
          prev.map((s) =>
            s.student_uuid === student_uuid
              ? { ...s, is_twin: 0, twin_student_id: null }
              : s.twin_student_id === student_uuid
              ? { ...s, is_twin: 0, twin_student_id: null }
              : s
          )
        );

        toast.success('Padanan pegawai telah dibatalkan');
      });

      return;
    }

    await updateTwinStatus(student_uuid, checked ? 1 : 0);

    setStudents((prev) =>
      prev.map((s) =>
        s.student_uuid === student_uuid
          ? {
              ...s,
              is_twin: checked ? 1 : 0,
              twin_student_id: checked ? s.twin_student_id : null,
            }
          : s.twin_student_id === student_uuid
          ? { ...s, is_twin: 0, twin_student_id: null }
          : s
      )
    );
  };

  const confirmUnpair = (onConfirm) => {
    toast(
      ({ closeToast }) => (
        <div>
          <div className="fw-semibold mb-2">Batalkan padanan pegawai?</div>

          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-danger"
              onClick={() => {
                closeToast();
                onConfirm();
              }}
            >
              Ya, batalkan
            </button>

            <button className="btn btn-sm btn-secondary" onClick={closeToast}>
              Batal
            </button>
          </div>
        </div>
      ),
      {
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
      }
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchStudents(page, perPage, search);
  };

  const handlePerPageChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchStudents(page, newPerPage, search);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    setCurrentPage(1);
    fetchStudents(1, perPage, value);
  };

  useEffect(() => {
    fetchStudents(currentPage, perPage, search);
  }, []);

  const columns = [
    {
      name: 'Nama Pegawai',
      selector: (row) => row.first_name,
      sortable: true,
      center: true,
      minWidth: '220px',
      cell: (row) => (
        <div style={{ fontWeight: 800, color: '#0f172a' }}>
          {row.first_name || '-'}
        </div>
      ),
    },
    {
      name: 'Jabatan / Unit',
      selector: (row) => row.class_name || 'Belum ditetapkan',
      center: true,
    },
    {
      name: 'Padanan',
      cell: (row) => (
        <div style={{ minWidth: 260 }}>
          <div className="form-check form-switch d-flex justify-content-center">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.is_twin}
              onChange={(e) =>
                handleTwinToggle(row.student_uuid, e.target.checked)
              }
            />
          </div>

          {row.is_twin === 1 && !row.twin_student_id && (
            <div className="mt-2">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Cari pegawai untuk dipadankan..."
                value={twinSearch[row.student_uuid] || ''}
                onChange={(e) => {
                  const q = e.target.value;
                  setTwinSearch((prev) => ({
                    ...prev,
                    [row.student_uuid]: q,
                  }));

                  if (q.length >= 2) {
                    searchTwinCandidates(row.student_uuid, q);
                  }
                }}
                style={smallInputStyle}
              />

              {twinResults[row.student_uuid]?.length > 0 && (
                <div className="list-group mt-1">
                  {twinResults[row.student_uuid].map((s) => (
                    <button
                      key={s.student_uuid}
                      className="list-group-item list-group-item-action"
                      onClick={() => pairTwin(row.student_uuid, s.student_uuid)}
                    >
                      {s.first_name} ({s.class_name || 'Tiada unit'})
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {row.is_twin === 1 && row.twin_student_id && (
            <div
              className="mt-2 p-2 border rounded text-center"
              style={{
                backgroundColor: '#eff6ff',
                borderColor: '#bfdbfe',
              }}
            >
              <div className="d-flex align-items-center justify-content-center gap-2">
                {row.twin_profile_pic && (
                  <img
                    src={row.twin_profile_pic}
                    alt="pegawai dipadankan"
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                )}

                <div>
                  <div className="fw-semibold text-dark">{row.twin_name}</div>
                  <small className="text-muted">{row.twin_class_name}</small>
                </div>
              </div>

              <button
                className="btn btn-sm btn-outline-danger mt-2"
                onClick={() => handleTwinToggle(row.student_uuid, false)}
              >
                Batal Padanan
              </button>
            </div>
          )}
        </div>
      ),
      center: true,
    },
    {
      name: 'Status',
      selector: (row) => {
        let label = 'Tiada Maklumat';
        let badgeClass = 'bg-secondary';
        const status = parseInt(row.status, 10);

        switch (status) {
          case 0:
            label = 'Belum Direkod';
            badgeClass = 'bg-warning';
            break;
          case 1:
            label = 'Sedang Direkod';
            badgeClass = 'bg-info';
            break;
          case 2:
            label = 'Profil Disambung';
            badgeClass = 'bg-success';
            break;
          case 4:
            label = 'Direkod Tanpa Profil';
            badgeClass = 'bg-danger';
            break;
          case 10:
            label = 'Tidak Aktif';
            badgeClass = 'bg-dark';
            break;
          case 11:
            label = 'Arkib';
            badgeClass = 'bg-dark';
            break;
          default:
            label = 'Tidak Diketahui';
            badgeClass = 'bg-secondary';
        }

        return <span className={`badge ${badgeClass}`}>{label}</span>;
      },
      center: true,
    },
    {
      name: 'Tindakan',
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button
            className="btn btn-sm"
            style={outlineBlueButtonStyle}
            onClick={() => {
              window.open(
                `/studentProfile?student_id=${row.student_uuid}`,
                '_blank'
              );
            }}
          >
            Lihat Laporan
          </button>
        </div>
      ),
      center: true,
    },
  ];

  return (
    <Fragment>
      <div
        className="container-fluid"
        style={{
          background: 'linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)',
          minHeight: '100vh',
          paddingTop: '24px',
          paddingBottom: '40px',
        }}
      >
        <div className="row">
          <div className="col-xl-12 xl-50">
            <div
              className="card rounded-25"
              style={{
                border: '1px solid #dbeafe',
                borderRadius: '22px',
                boxShadow: '0 18px 45px rgba(11, 76, 156, 0.10)',
                overflow: 'hidden',
              }}
            >
              <div
                className="card-header rounded-25 d-flex justify-content-between align-items-center"
                style={{
                  background:
                    'linear-gradient(135deg, #0B4C9C 0%, #0F65C9 55%, #1E88E5 100%)',
                  borderBottom: 'none',
                  padding: '22px 26px',
                  gap: '16px',
                  flexWrap: 'wrap',
                }}
              >
                <div>
                  <div
                    style={{
                      color: '#bfdbfe',
                      fontSize: '12px',
                      fontWeight: 800,
                      letterSpacing: '0.12em',
                      textTransform: 'uppercase',
                      marginBottom: '6px',
                    }}
                  >
                    Pengurusan Pegawai
                  </div>

                  <h5
                    className="mb-0"
                    style={{
                      color: '#ffffff',
                      fontWeight: 800,
                    }}
                  >
                    Senarai Pegawai
                  </h5>

                  <p
                    style={{
                      color: '#dbeafe',
                      margin: '6px 0 0',
                      fontSize: '14px',
                    }}
                  >
                    Semak maklumat pegawai, status rekod wajah, jabatan/unit dan
                    laporan kehadiran.
                  </p>
                </div>

                <input
                  type="text"
                  className="form-control form-control-sm"
                  style={{
                    maxWidth: '280px',
                    borderRadius: '14px',
                    borderColor: '#bfdbfe',
                    padding: '11px 14px',
                  }}
                  placeholder="Cari nama pegawai..."
                  value={search}
                  onChange={handleSearch}
                />
              </div>

              <div
                className="card-body"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '22px',
                }}
              >
                <DataTable
                  columns={columns}
                  data={students}
                  striped={false}
                  persistTableHead
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={perPage}
                  paginationRowsPerPageOptions={[10, 20, 50]}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                  highlightOnHover
                  customStyles={blueDataTableStyles}
                  noDataComponent={
                    <div
                      style={{
                        padding: '36px 16px',
                        color: '#64748b',
                        fontWeight: 600,
                      }}
                    >
                      Tiada pegawai dijumpai buat masa ini.
                    </div>
                  }
                  expandableRows
                  expandableRowsComponent={({ data }) => {
                    const summary = expandedRows[data.student_uuid];

                    if (!summary) {
                      return (
                        <div className="p-3" style={{ color: '#64748b' }}>
                          Sedang memuatkan ringkasan...
                        </div>
                      );
                    }

                    return (
                      <div className="p-3">
                        <h6
                          className="mb-2"
                          style={{
                            color: '#0B4C9C',
                            fontWeight: 800,
                          }}
                        >
                          Ringkasan Kehadiran ({summary.year})
                        </h6>

                        <div className="table-responsive d-inline-block">
                          <table
                            className="table table-sm table-bordered align-middle mb-0"
                            style={{ width: 'auto' }}
                          >
                            <thead className="table-light">
                              <tr>
                                <th>Bulan</th>
                                <th className="text-center">Hadir</th>
                                <th className="text-center">Tidak Hadir</th>
                                <th className="text-center">Jumlah Hari</th>
                              </tr>
                            </thead>

                            <tbody>
                              {summary.summary.map((month, idx) => (
                                <React.Fragment key={idx}>
                                  <tr>
                                    <td>
                                      <strong>{month.month}</strong>
                                    </td>
                                    <td className="text-success text-center">
                                      {month.present_days}
                                    </td>
                                    <td className="text-danger text-center">
                                      {month.absent_days}
                                    </td>
                                    <td className="text-center">
                                      {month.total_days}
                                    </td>
                                  </tr>

                                  {month.details?.length > 0 && (
                                    <tr>
                                      <td colSpan="4" className="bg-light">
                                        <ul className="list-unstyled mb-0 ps-2">
                                          {month.details.map((detail, i) => (
                                            <li key={i}>
                                              <strong>{detail.date}</strong>:{' '}
                                              {detail.reason || 'Tiada sebab'}{' '}
                                              {detail.letter_attachment_url && (
                                                <a
                                                  href={
                                                    detail.letter_attachment_url
                                                  }
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-primary"
                                                >
                                                  (Lihat Dokumen)
                                                </a>
                                              )}
                                            </li>
                                          ))}
                                        </ul>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  }}
                  expandableRowExpanded={(row) => !!expandedRows[row.student_uuid]}
                  onRowExpandToggled={(expanded, row) => {
                    if (expanded && !expandedRows[row.student_uuid]) {
                      fetchStudentSummary(row.student_uuid);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OfficerPage;

const blueDataTableStyles = {
  table: {
    style: {
      width: '100%',
      borderRadius: '18px',
      overflow: 'hidden',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#eff6ff',
      borderBottomColor: '#bfdbfe',
      minHeight: '56px',
    },
  },
  headCells: {
    style: {
      color: '#0B4C9C',
      fontSize: '12px',
      fontWeight: 900,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
    },
  },
  rows: {
    style: {
      minHeight: '64px',
      borderBottomColor: '#e5eefb',
      fontSize: '14px',
      color: '#0f172a',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#eff6ff',
    },
  },
  pagination: {
    style: {
      borderTopColor: '#dbeafe',
      color: '#334155',
    },
  },
};

const outlineBlueButtonStyle = {
  backgroundColor: '#ffffff',
  color: '#0B4C9C',
  border: '1px solid #0B4C9C',
  borderRadius: '10px',
  fontWeight: 800,
  padding: '7px 13px',
  fontSize: '12px',
};

const smallInputStyle = {
  borderRadius: '10px',
  borderColor: '#bfdbfe',
};